import { live, LiveController, RubySymbol } from "@camertron/live-component";
import { StopwatchComponent } from "../stopwatch";
import { celebrate } from "../celebrate";

export interface GameComponent {
  elapsedStopwatchTargetComponent: StopwatchComponent;
  bestStopwatchTargetComponent: StopwatchComponent;
}

type GameComponentProps = {
  puzzle_id: number,
  definition: string
  grid_state: string
  direction: RubySymbol
  entry_mode: RubySymbol
  phase: RubySymbol
}

@live("Crossword::GameComponent")
export class GameComponent extends LiveController<GameComponentProps> {
  static targets = ["elapsedStopwatch", "bestStopwatch"];

  private save_interval_id: number | null = null;

  override after_update() {
    switch (this.props.phase.value) {
      case "finishing":
        this.finish();
        break;

      case "in_progress":
        this.start();
        break;
    }
  }

  finish() {
    celebrate();
    this.props.phase.value = "finished"
    this.render();
    this.stop();
  }

  stop() {
    this.elapsedStopwatchTargetComponent?.stop();
    this.stop_saving();
  }

  start() {
    this.elapsedStopwatchTargetComponent?.start();
    this.save_periodically();
  }

  on_square_click(x: number, y: number) {
    this.render((component) => {
      component.call("on_square_click", { x, y });
    });
  }

  on_square_keydown(key: string) {
    this.render((component) => {
      component.call("on_square_keydown", { key });
    });
  }

  private save_periodically() {
    if (!this.save_interval_id) {
      /* @ts-ignore */
      this.save_interval_id = setInterval(this.update_attempt.bind(this), 5_000);
    }
  }

  private stop_saving() {
    if (this.save_interval_id) {
      clearInterval(this.save_interval_id);
      this.save_interval_id = null;

      // make sure we save one last time before pausing
      this.update_attempt();
    }
  }

  disconnect() {
    this.stop_saving();
  }

  private update_attempt() {
    const csrf_param = document.querySelector("meta[name='csrf-param']")?.getAttribute("content");
    const csrf_token = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

    fetch(`/puzzles/${this.props.puzzle_id}/attempts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: 'include',
      body: JSON.stringify({
        [csrf_param!]: csrf_token!,
        attempt: {
          state: this.props.grid_state,
          phase: this.props.phase.value,
          elapsed_msecs: this.elapsedStopwatchTargetComponent.elapsed_msecs
        }
      })
    });
  }
}
